// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./IndicatorTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Indicator-module__Container__s7yQv {
    position: absolute;
    /* The border is defined as an outline to not affect the overall size of the component, which is determined by the min-width and height properties.
     * otherwise we cannot match the design requirements */
    outline: var(--ds-border-width) solid var(--ds-indicator-border-color);
    box-shadow: var(--ds-shadow-shallow);
}
/* --- Sizes --- */

.Indicator-module__Large__xPlRT {
    min-width: var(--ds-6x);
    height: var(--ds-6x);
}

.Indicator-module__Small__RuscV {
    min-width: var(--ds-4x);
    height: var(--ds-4x);
}

.Indicator-module__Tiny__Tv9FV {
    min-width: var(--ds-2x);
    height: var(--ds-2x);
}
/* --- Content-type padding --- */
/* Only add the additional padding when we're displaying a number as the Icons properly sit in the middle and do not need to 'stretch' the Indicator */

.Indicator-module__NumberContent__i1WcW {
    padding: 0 var(--ds-xs);
}
/* --- Variant colors --- */

.Indicator-module__Highlight__sTIDh {
    color: var(--ds-indicator-color-light);
    background-color: var(--ds-indicator-bg-highlight);
}

.Indicator-module__Neutral__Oo2Vq {
    color: var(--ds-indicator-color-brand);
    background-color: var(--ds-indicator-bg-neutral);
}

.Indicator-module__Danger__CV0f6 {
    color: var(--ds-indicator-color-dark);
    background-color: var(--ds-indicator-bg-danger);
}

.Indicator-module__Alert__TQ3Jp {
    color: var(--ds-indicator-color-dark);
    background-color: var(--ds-indicator-bg-alert);
}

.Indicator-module__Positive__gYTU3 {
    color: var(--ds-indicator-color-dark);
    background-color: var(--ds-indicator-bg-positive);
}

.Indicator-module__Informative__R9b_R {
    color: var(--ds-indicator-color-dark);
    background-color: var(--ds-indicator-bg-informative);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Indicator-module__Container__s7yQv`,
	"Large": `Indicator-module__Large__xPlRT`,
	"Small": `Indicator-module__Small__RuscV`,
	"Tiny": `Indicator-module__Tiny__Tv9FV`,
	"NumberContent": `Indicator-module__NumberContent__i1WcW`,
	"Highlight": `Indicator-module__Highlight__sTIDh`,
	"Neutral": `Indicator-module__Neutral__Oo2Vq`,
	"Danger": `Indicator-module__Danger__CV0f6`,
	"Alert": `Indicator-module__Alert__TQ3Jp`,
	"Positive": `Indicator-module__Positive__gYTU3`,
	"Informative": `Indicator-module__Informative__R9b_R`
};
export default ___CSS_LOADER_EXPORT___;
